import store from '../store'
import { setIsPopoverChatOpen } from '../store/general/actions'
import {
  addPopoverNotificationMessage,
  addUserMessageToSend,
} from '../store/maya/actions'

// FUNCTION OUR CLIENTS CAN USE TO OPEN THE MAYA POPOVER CHAT
export const openMayaPopoverChat = (state = true) => {
  // EXAMPLE USAGE: window.openMayaPopoverChat(true)
  store.dispatch(setIsPopoverChatOpen(state))
}

// FUNCTION OUR CLIENTS CAN USE TO ADD A POPOVER NOTIFICATION MESSAGE
export const addMayaPopoverNotification = message => {
  // EXAMPLE USAGE: window.addMayaPopoverNotification('This is a test notification')
  store.dispatch(addPopoverNotificationMessage(message))
}

// FUNCTION OUR CLIENTS CAN USE TO SEND A USER MESSAGE TO MAYA
export const sendMayaUserMessage = message => {
  // EXAMPLE USAGE: window.sendMayaUserMessage('This is a test message')

  console.log('sendMayaUserMessage called with message =>', message)
  addUserMessageToSend({ message: message })
}
